export default __webpack_public_path__ + "static/media/Jeremy Selwin.d7c97dea.png";